import { defineCopy } from "@tami/core/intl";

import { DEMO_TABS_COPY_EN_US } from "./en-us/demo-tabs.copy";
import { DEMO_TABS_COPY_ES_ES } from "./es-es/demo-tabs.copy";

export const DEMO_TABS_COPY_PT_BR = {
  painel: "Painel",
  creators: "Creators",
  notas: "Notas",
  conteudo: "Conteúdo",
  campanhas: "Campanhas",
  financas: "Finanças",
  calculadora: "Calculadora",
  desempenho: "Desempenho",
  agenda: "Agenda",
  equipe: "Fluxo",
  whatsapp: "WhatsApp",
} as const;

export const DEMO_TABS_COPY = defineCopy(DEMO_TABS_COPY_PT_BR, {
  "en-US": DEMO_TABS_COPY_EN_US,
  "es-ES": DEMO_TABS_COPY_ES_ES,
});
